<div class="forgot-password-wrapper">
  <img role="presentation" src="assets/images/illustrations/light-beige.svg" class="background-image" />
  <div class="recovery-card" style="-webkit-overflow-scrolling: touch">
    <div class="left">
      <p>Looks like you need to reset your password</p>
      <img role="presentation" src="assets/images/signin/illustration_recover_password.svg" />
    </div>
    <div class="right">
      <a class="arrow-back" (click)="handleBack()">
        <svg width="24" height="10" viewBox="0 0 24 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5.59998 9.00006L1.59998 5.00006L5.59998 1.00006M1.59998 5.00006H22.4H1.59998Z"
            stroke="#333333"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
      <div class="content">
        <div>
          <p class="title">{{ codeSent ? 'Code Sent' : 'Reset Password' }}</p>
          <p class="info">
            {{
              codeSent
                ? 'If you didn’t get a code, press “Request Code” again. If the problem persists, please contact support.'
                : 'You can only reset your password if you did not sign up using a third-party account (i.e. Apple, Google, Microsoft).*'
            }}
          </p>

          @if (!codeSent) {
            <form [formGroup]="phoneForgotForm">
              @if (showVerifyingText) {
                <label class="indicator-label">Verifying email...</label>
              }
              <div class="form-container">
                <sign-in-flag-input (inputEvent)="requestCodeEvent($event)"></sign-in-flag-input>
                <button
                  class="flat-button"
                  data-testid="request-code-button"
                  (click)="requestCode()"
                  [disabled]="requestCodeFormInvalid()"
                  style="margin-top: 10px"
                >
                  Request Code
                </button>
                @if (errors.phoneNumber) {
                  <mat-error>{{ errors.phoneNumber }}</mat-error>
                }
              </div>
            </form>
          }

          <div class="form-container">
            @if (codeSent) {
              <button
                class="flat-button"
                data-testid="re-request-code-button"
                (click)="requestCode(forgotLoginInput)"
                [disabled]="requestCodeFormInvalid()"
              >
                Request Code
              </button>
            }
          </div>

          <!-- - - - - - - - - - - - - - RESET PASSWORD INPUT - - - - - - - - - - - - -->
          @if (codeSent) {
            <form class="form-container password-form">
              @if (errors.confirmationCode) {
                <mat-error class="no-margin">{{ errors.confirmationCode }}</mat-error>
              }
              <mat-form-field class="code-input" hideRequiredMarker>
                <mat-label>Confirmation Code</mat-label>
                <input
                  matInput
                  id="confirmationCode"
                  data-testid="confirmation-code-input"
                  placeholder="XXXXXX"
                  [formControl]="code"
                  type="number"
                />
              </mat-form-field>
              @if (errors.password) {
                <mat-error class="no-margin">{{ errors.password }}</mat-error>
              }
              <mat-form-field class="code-input" hideRequiredMarker>
                <mat-label>New Password</mat-label>
                <input
                  matInput
                  id="password"
                  data-testid="password-input"
                  placeholder="XXXXXX"
                  [formControl]="password"
                  type="password"
                  required
                />
              </mat-form-field>
              <mat-form-field class="code-input" hideRequiredMarker>
                <mat-label>Confirm Password</mat-label>
                <input
                  matInput
                  id="confirmPassword"
                  data-testid="confirm-password-input"
                  placeholder="XXXXXX"
                  [formControl]="confirmPassword"
                  type="password"
                  required
                />
              </mat-form-field>
              <!-- SUBMIT NEW PASSWORD -->
              <button
                class="flat-button"
                data-testid="submit-password-button"
                (click)="submitNewPassword()"
                [disabled]="!code.valid || !password.valid || password.value !== confirmPassword.value"
              >
                Change password
              </button>
            </form>
          }
        </div>

        <!-- THIRD PARTY AUTHENTICATORS  -->
        @if (!codeSent) {
          <p class="warning">
            *If you registered using your Apple, Google, or Microsoft account, you will not have a phone number
            associated with your account, nor will you have a Scoot-specific password. If you signed up with any of
            these third party accounts, and don’t remember your password, go to that account to reset your password.
          </p>
        }
      </div>
    </div>
  </div>
</div>
